import SongPart from './SongPart';

export default SongPart;
